/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const CONTENT_MATRIX_IDENTIFIER_DATA_IDS = {
  createIdentifier: `Add content matrix identifier button`,
  createIdentifierApiKey: 'Create content matrix identifier api key form field',
  createIdentifierApiUrl: 'Create content matrix identifier api url form field',
  createIdentifierCancel: 'Cancel create content matrix identifier button',
  createIdentifierConfirm: 'Confirm create content matrix identifier button',
  createIdentifierForm: 'Create content matrix identifier form',
  createIdentifierName: 'Create content matrix identifier name form field',
  editIdentifier: 'Edit content matrix identifier button',
  list: 'Content matrix identifier list',
  listEmptyState: 'Content matrix identifier list empty state',
  showMore: 'Show more content matrix identifiers button',
};

export const CONTENT_MATRIX_IDENTIFIER_FORM_IDS = {
  apiKey: 'content-matrix-identifier-api-key',
  apiUrl: 'content-matrix-identifier-api-url',
  name: 'content-matrix-identifier-name',
};
